/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupManagementModel } from '../../models/group-management-model';
import { GroupManagementModelApiRespModel } from '../../models/group-management-model-api-resp-model';

export interface ApiManagementGroupAddPost$Params {
      body?: GroupManagementModel
}

export function apiManagementGroupAddPost(http: HttpClient, rootUrl: string, params?: ApiManagementGroupAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupManagementModelApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiManagementGroupAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GroupManagementModelApiRespModel>;
    })
  );
}

apiManagementGroupAddPost.PATH = '/api/Management/Group/Add';
